import React from "react";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { useState } from "react";
import { inviteApi } from "../services/api";
import "../assets/styles/InviteUserModal.scss";

export interface Props {
    onHide: () => void;
    refreshUsers: () => void;
    show: boolean;
}

const InviteUserModal: React.FC<Props> = (props: Props) => {
    const { refreshUsers } = props;
    const [formData, setFormData] = useState({ firstName: '', lastName: '', email: '' });
    const [error, setError] = useState("");

    const isEmailValid = (e) => {
        const email = e.target.value;
        // eslint-disable-next-line no-useless-escape
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            setError("");
            return (true);
        }
        else {
            setError("Please enter valid format of email address");
            return (false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        /* istanbul ignore if  */
        if (error) return;
        else {
            inviteApi(formData).then(() => {
                refreshUsers();
                props.onHide();
                toast.success("Invitation sent");
                setFormData({ firstName: '', lastName: '', email: '' });
            }).catch((err) => {
                err.then((err1) => {
                    toast.error(err1);
                });
            });
        }
    };

    return (
        <Modal show={props.show} onHide={props.onHide} id="InviteUserModal"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header id="closebtn" closeButton>
                <Modal.Title id="title">Invite User</Modal.Title>
            </Modal.Header>
            <form onSubmit={handleSubmit} data-testid="inviteform">
                <Modal.Body>
                    <div className="modal-body" id="body">
                        <div className="row mb-3 mt-3" id="row-1">
                            <div className="col-1"></div>
                            <label className="col-3 col-form-label" id="fname">First Name<em className="text-danger">*</em></label>
                            <div className="col-7">
                                <input type="text" className="form-control" data-testid="recipient-fname" placeholder="Enter First Name" value={formData.firstName}
                                    onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                                    onInvalid={e => (e.target as HTMLInputElement).setCustomValidity('Please enter your first name')}
                                    onInput={e => (e.target as HTMLInputElement).setCustomValidity('')} required />
                            </div>
                            <div className="col-1"></div>
                        </div>
                        <div className="row mb-3" id="row-2">
                            <div className="col-1"></div>
                            <label className="col-3 col-form-label" id="lname">Last Name<em className="text-danger">*</em></label>
                            <div className="col-7">
                                <input className="form-control" data-testid="recipient-lname" placeholder="Enter Last Name" value={formData.lastName}
                                    onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                                    onInvalid={e => (e.target as HTMLInputElement).setCustomValidity('Please enter your last name')}
                                    onInput={e => (e.target as HTMLInputElement).setCustomValidity('')} required />
                            </div>
                            <div className="col-1"></div>
                        </div>
                        <div className="row mb-3" id="row-3">
                            <div className="col-1"></div>
                            <label className="col-3 col-form-label" id="email">Email<em className="text-danger">*</em></label>
                            <div className="col-7">
                                <input className={`form-control ${error ? "is-invalid" : ""}`} data-testid="email" placeholder="Enter Email" value={formData.email}
                                    onChange={(e) => { setFormData({ ...formData, email: e.target.value }); isEmailValid(e); }} onInvalid={e => (e.target as HTMLInputElement).setCustomValidity('Please enter your e-mail address')}
                                    onInput={e => (e.target as HTMLInputElement).setCustomValidity('')} required />
                                <span data-testid="errormsg" className='error text-danger mt-1 ms-1' style={{ fontSize: '12px', lineHeight: '110%', display: 'block' }} >{error} </span>
                            </div>
                            <div className="col-1"></div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer id="footer">
                    <button type="button" className="btn btn-secondary" data-testid="cancle-button" onClick={props.onHide} >Cancel</button>
                    <button type="submit" className="btn btn-primary" data-testid="submit-button" >Send Invite</button>
                </Modal.Footer>
            </form >
        </Modal >
    );
};

export default InviteUserModal;
